import { useState, useRef, useEffect } from "react";
import "../UserProfile.css";
import {
  TabStrip,
  TabStripTab,
  type TabStripSelectEventArguments,
} from "@progress/kendo-react-layout";
import { ICON_BASE_PATH } from "@/app/utils/config";
import PersonalInfo from "./PersonalInfo";
import CompanyInfo from "./CompanyInfo";
import SettingsInfo from "./SettingsInfo";
import { t } from "i18next";
import { useUserDetails } from "@/app/services/context/UserDetailsContext";

interface Props {
  selectedTab?: number;
}

const PersonalInformation: React.FC<Props> = ({ selectedTab = 0 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<number>(selectedTab);
  const { personalInfo, personalInfoLoading, fetchPersonalInfo } =
    useUserDetails();

  // ............................... useRef ................................
  const menuRef = useRef<HTMLDivElement>(null);

  // ............................... handleSelect ................................
  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  // ............................... handleTermsofService ................................
  const handleTermsofService = () => {
    window.open("/termsofservice", "_blank", "noopener,noreferrer");
  };

  // ............................... handlePrivacy ................................
  const handlePrivacy = () => {
    window.open("/privacypolicy", "_blank", "noopener,noreferrer");
  };

  // ............................... useEffect ................................
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="gx-cardPersonalInformation">
      <div className="grid grid-cols-12">
        <div className="col-span-12">
          <div className="gx-profile-tab">
            <TabStrip selected={selected} onSelect={handleSelect}>
              <TabStripTab title={t("personal_info")}>
                <PersonalInfo
                  personalInfo={personalInfo}
                  personalInfoLoading={personalInfoLoading}
                  fetchPersonalInfo={fetchPersonalInfo}
                />
              </TabStripTab>
              <TabStripTab title={t("company_info")}>
                <CompanyInfo personalInfo={personalInfo} />
              </TabStripTab>
              <TabStripTab title={t("settings")}>
                <SettingsInfo />
              </TabStripTab>
            </TabStrip>

            <button
              type="button"
              className="dot-icon"
              onClick={() => setIsOpen((prev) => !prev)}
              aria-label="Open menu"
            >
              <img src={`${ICON_BASE_PATH}dot.svg`} alt="" />
            </button>
          </div>

          {isOpen && (
            <div ref={menuRef} className="open-list active">
              <ul>
                <li>
                  <button onClick={handleTermsofService}>
                    <img src={`${ICON_BASE_PATH}term.svg`} alt="Terms" />
                    <span>Terms and Conditions</span>
                  </button>
                </li>
                <li>
                  <button onClick={handlePrivacy}>
                    <img src={`${ICON_BASE_PATH}privacy.svg`} alt="Privacy" />
                    <span>Privacy Policy</span>
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
      
    </div>
  );
};

export default PersonalInformation;
